<template>
    <el-popover
        v-if="rangeSelect"
        placement="bottom"
        trigger="click"
        @hide="hidePopperSearch(valueHere)">
        <div class="th-filter-down" slot="reference">
            <slot name="icon">
                <i :class="['el-icon-arrow-down', iconActive ? 'el-icon-arrow-down-active' : '']"></i>
            </slot>
        </div>
        <el-date-picker
            ref="datepicker"
            v-model="valueHere"
            class="wl-item wl-date-item input-with-select"
            type="daterange"
            :range-separator="$t('date_filter_middle')"
            :start-placeholder="$t('date_filter_begin')"
            :end-placeholder="$t('date_filter_end')"
            value-format="yyyy-MM-dd"
        ></el-date-picker>
    </el-popover>
    <div class="multiselect-container" v-else>
        <div class="th-filter-down" @click="onDropdownClick">
            <slot name="icon">
                <i :class="['el-icon-arrow-down', iconActive ? 'el-icon-arrow-down-active' : '']"></i>
            </slot>
        </div>
        <el-date-picker
            ref="datepicker"
            v-model="valueHere"
            class="wl-item wl-date-item input-with-select"
            style="visibility: hidden; position:absolute; top:0; left:0; z-index:-1;"
            type="date"
            :range-separator="$t('date_filter_middle')"
            :start-placeholder="$t('date_filter_begin')"
            :end-placeholder="$t('date_filter_end')"
            value-format="yyyy-MM-dd"
            @change="onValueChange"
        ></el-date-picker>
    </div>
</template>
<script>
export default {
    name: 'DatePickerPopover',
    props: {
        hidePopperSearch: {
            type: Function,
            default: () => {}
        },
        value: {
            type: Array|String,
            default: null
        },
        rangeSelect: {
            type: Boolean,
            default: true
        }
    },
    data() { return {
        topicInputFilter: '',
        valueHere: []
    }},
    created() {
        if (this.rangeSelect) {
            // this.value = ['', '']
            this.valueHere = ['', '']
        } else {
            // this.value = ''
            this.valueHere = ''
        }
    },
    methods: {
        onDropdownClick() {
            this.$refs.datepicker.showPicker()
        },
        onValueChange() {
            this.$emit('update:value', this.valueHere)
            this.hidePopperSearch(this.valueHere)
        }
    },
    watch: {
        valueHere(v) {
            this.$emit('update:value', v ? v : (this.rangeSelect ? ['', ''] : ''))
        },
        value(v) {
            this.valueHere = v ? v : (this.rangeSelect ? ['', ''] : '')
        }
    },
    computed: {
        iconActive() {
            if (this.rangeSelect) {
                return this.valueHere && this.valueHere.some(v => v !== '')
            } else {
                return this.valueHere
            }
        }
    }
}
</script>
<style scoped>
.multiselect-container {
    display: flex;
    flex-direction: column;
    max-width: 100vw;
    max-height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.multiselect-container::-webkit-scrollbar { width: 0!important }
.multiselect-container { -ms-overflow-style: none; }
.multiselect-container { overflow: -moz-scrollbars-none; }

.multiselect-container .input-filter {}
.multiselect-container .selectall-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin: 10px 0;
}
.multiselect-container .selectall-row .selectall-item {
    color: #409eff;
    margin-left: 10px;
    cursor: pointer;
}
.multiselect-container .group-check {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}
.multiselect-container .group-check .group-check-checkbox {
    width: 100%;
    margin-bottom: 12px;
}
.multiselect-container .group-check .group-check-checkbox .checkbox-text {
    margin-left: 10px;
}

</style>